// extracted by mini-css-extract-plugin
module.exports = {"availability":"availability___3C-SG"};